// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"dc89875e","453":"f0f2b954"}[chunkId] + ".chunk.js";
};